// Estilos base del proveedor antes de las adaptaciones del DS.
import 'react-toastify/dist/ReactToastify.css';
// Capa DS (orden fijo: a igual especificidad manda el orden de inyección).
// fonts → tokens → base (lienzo) → primitivas (componentes y cromo) →
// una hoja por pantalla → marca de pendientes.
import './styles/revopic-ds/fonts.css';
import './styles/revopic-ds/tokens.css';
import './styles/revopic-ds/base.css';
import './styles/revopic-ds/rev-primitives.css';
import './styles/revopic-ds/rev-toasts.css';
import './styles/revopic-ds/screens/evento-datos-basicos.css';
import './styles/revopic-ds/screens/evento-precios.css';
import './styles/revopic-ds/screens/evento-compartir.css';
import './styles/revopic-ds/screens/evento-estadisticas.css';
import './styles/revopic-ds/screens/evento-fotos.css';
import './styles/revopic-ds/screens/evento-galeria.css';
import './styles/revopic-ds/screens/evento-pagos.css';
import './styles/revopic-ds/screens/eventos.css';
import './styles/revopic-ds/screens/creditos.css';
import './styles/revopic-ds/screens/evento-cupones.css';
import './styles/revopic-ds/screens/guia.css';
import './styles/revopic-ds/screens/evento-marca-agua.css';
import './styles/revopic-ds/screens/evento-patrocinadores.css';
import './styles/revopic-ds/screens/evento-galeria-publica.css';
import './styles/revopic-ds/screens/acceso.css';
import './styles/revopic-ds/screens/ajustes-cobros.css';
import './styles/revopic-ds/pendiente.css';
// Antidoto de la hoja global de terceros (public/index.html:11). No es capa DS:
// va la ultima y solo revierte lo que esa hoja fuerza con !important.
import './styles/blob-neutralize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Amplify} from "aws-amplify";

Amplify.configure({
    Auth: {
        region: 'eu-west-1',
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        storage: window.localStorage, 
        keyPrefix: 'app-revopic-',
        oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN,
            scope: ['openid', 'email', 'profile', 'phone', 'aws.cognito.signin.user.admin' ],
            redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN,  
            redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT, 
            responseType: 'code',
        }
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_PHOTOS_BUCKET,
            region: 'eu-west-1',
            transferAcceleration: true,
        }
    }
});

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
